export default "__VITE_ASSET__BTfaefgc__"